// extracted by mini-css-extract-plugin
module.exports = {"organizationSelector":"styles_organizationSelector__2PVYS"};